import {
  IconAustria,
  IconBelgium,
  IconBulgaria,
  IconCroatia,
  IconDenmark,
  IconEarth,
  IconFinland,
  IconFrance,
  IconGermany,
  IconGreece,
  IconIreland,
  IconItaly,
  IconLuxembourg,
  IconMalta,
  IconNetherlands,
  IconNorway,
  IconPoland,
  IconPortugal,
  IconRomania,
  IconScotland,
  IconSpain,
  IconSweden,
  IconSwitzerland,
  IconGreatBritain,
  IconUnitedKingdom,
} from '../components';

export const getCountryFlagById = id => {
  switch (id) {
    case 'option-value-austria':
      return <IconAustria />;
    case 'option-value-belgium':
      return <IconBelgium />;
    case 'option-value-bulgaria':
      return <IconBulgaria />;
    case 'option-value-croatia':
      return <IconCroatia />;
    case 'option-value-denmark':
      return <IconDenmark />;
    case 'option-value-finland':
      return <IconFinland />;
    case 'option-value-france':
      return <IconFrance />;
    case 'option-value-germany':
      return <IconGermany />;
    case 'option-value-greece':
      return <IconGreece />;
    case 'option-value-ireland':
      return <IconIreland />;
    case 'option-value-italy':
      return <IconItaly />;
    case 'option-value-luxembourg':
      return <IconLuxembourg />;
    case 'option-value-malta':
      return <IconMalta />;
    case 'option-value-netherlands':
      return <IconNetherlands />;
    case 'option-value-norway':
      return <IconNorway />;
    case 'option-value-poland':
      return <IconPoland />;
    case 'option-value-portugal':
      return <IconPortugal />;
    case 'option-value-romania':
      return <IconRomania />;
    case 'option-value-scotland':
      return <IconScotland />;
    case 'option-value-spain':
      return <IconSpain />;
    case 'option-value-sweden':
      return <IconSweden />;
    case 'option-value-switzerland':
      return <IconSwitzerland />;
    case 'option-value-great-britain':
      return <IconGreatBritain />;
    case 'option-value-unitedKingdom':
      return <IconUnitedKingdom />;
    case 'all-countries':
      return <IconEarth />;
    default:
      return '';
  }
};

export const getCountryFlagByName = name => {
  switch (name) {
    case 'Austria':
      return <IconAustria />;
    case 'Belgium':
      return <IconBelgium />;
    case 'Bulgaria':
      return <IconBulgaria />;
    case 'Croatia':
      return <IconCroatia />;
    case 'Denmark':
      return <IconDenmark />;
    case 'Finland':
      return <IconFinland />;
    case 'France':
      return <IconFrance />;
    case 'Germany':
      return <IconGermany />;
    case 'Greece':
      return <IconGreece />;
    case 'Ireland':
      return <IconIreland />;
    case 'Italy':
      return <IconItaly />;
    case 'Luxembourg':
      return <IconLuxembourg />;
    case 'Malta':
      return <IconMalta />;
    case 'Netherlands':
      return <IconNetherlands />;
    case 'Norway':
      return <IconNorway />;
    case 'Poland':
      return <IconPoland />;
    case 'Portugal':
      return <IconPortugal />;
    case 'Romania':
      return <IconRomania />;
    case 'Scotland':
      return <IconScotland />;
    case 'Spain':
      return <IconSpain />;
    case 'Sweden':
      return <IconSweden />;
    case 'Switzerland':
      return <IconSwitzerland />;
    case 'GreatBritain':
      return <IconGreatBritain />;
    case 'UnitedKingdom':
      return <IconUnitedKingdom />;
    default:
      return '';
  }
};
